export default __webpack_public_path__ + "static/junyoungkim-c30617c00271ea893618975ff6356688.jpeg";